export default "__VITE_ASSET__CRJxZOlQ__"